import { render, staticRenderFns } from "./Preaspirante.vue?vue&type=template&id=794299d5"
import script from "./Preaspirante.vue?vue&type=script&lang=js"
export * from "./Preaspirante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports